module.exports = __webpack_public_path__ + "static/media/Wohnen-min.672c41e9.jpg";